(function ($) {
  $(document).ready(function () {
    if ($(".account-form").length > 0) {
      $(
        ".account-form .account-form-wrap .select-box-wrap .select-box"
      ).on("click", function () {
        $(this).parent().toggleClass("text-black");
      });
      $(".account-form .account-form-wrap .select-box-wrap .select-box #country").on("change", function () {
        var countryVal = $(this).val(); 
        if(countryVal == 'United States') {
          $(".account-form .account-form-wrap .select-box-wrap .state-wrapper").show();
        } else {
          $(".account-form .account-form-wrap .select-box-wrap .state-wrapper").hide();
        }
      });
    }

    //for-placeholder

    $(".account-form .form-content-wrap .row-wrapper input")
      .focus(function () {
        $(this).parent(".row-wrapper").addClass("placeholder");
      })
      .blur(function () {
        $(this).parent(".row-wrapper").removeClass("placeholder");
      });

    $(".account-form .form-content-wrap .row-wrapper").on(
      "blur",
      "input",
      function () {
        if ($(this).val()) {
          $(this).parent().addClass("used");
          $(this).parent().addClass("used-active");
        } else {
          $(this).parent().removeClass("used");
          $(this).parent().removeClass("used-active");
        }
      }
    );

    $(".account-form .form-content-wrap .password input")
      .focus(function () {
        $(this).parent(".password").addClass("placeholder");
      })
      .blur(function () {
        $(this).parent(".password").removeClass("placeholder");
      });


    $(".account-form .form-content-wrap .optional-information-wrap .organization input"
    )
      .focus(function () {
        $(this).parent(".organization").addClass("placeholder");
      })
      .blur(function () {
        $(this).parent(".organization").removeClass("placeholder");
      });

      //password

      $(".account-form .form-content-wrap .password .eye-wrap").on("click", function () {
        var x = $(this).closest('.password').find('input').attr('type');

        if (x.toString() === "password") {
          x = "text";
          $(this).closest('.password').find('input').attr('type', x );
          $(this).addClass("eye-active");
        } else {
          x = "password";
          $(this).closest('.password').find('input').attr('type', x );
          $(this).removeClass("eye-active");
        }
      });


    //side-bar

    $(
      ".account-form-wrap .side-bar .img-wrapper .img-wrap"
    ).click(function () {
      $(this).toggleClass("image-active");
      $(
        ".account-form-wrap .side-bar .img-wrapper .img-wrap"
      )
        .not(this)
        .removeClass("image-active");
    });
  });





  
})(jQuery);
